import { Bound } from "lib/@components/binding/Bound"
import { useBoundContext } from "lib/@components/binding/use-bound-context"

export function TargetEditor({ children }) {
    const { editorTarget } = useBoundContext()
    return (
        <Bound target={editorTarget} compare={editorTarget}>
            {children}
        </Bound>
    )
}
